import ApiService from "@/utils/api.service";

export default {
    users() {
        return new Promise(resolve => {
            ApiService.get("statistiques/users").then(data => { resolve(data) })
        })
    },
    accounts() {
        return new Promise(resolve => {
            ApiService.get("statistiques/accounts").then(data => { resolve(data) })
        })
    },

    orders() {
        return new Promise(resolve => {
            ApiService.get("statistiques/orders").then(data => { resolve(data) })
        })
    },
    getTurnover() {
        return new Promise(resolve => {
            ApiService.get("statistiques/turnover").then(data => { resolve(data) })
        })
    },

    openOrders() {
        return new Promise(resolve => {
            ApiService.get("statistiques/open-orders").then(data => { resolve(data) })
        })
    },
    favoritService() {
        return new Promise(resolve => {
            ApiService.get("statistiques/service-favorite").then(data => { resolve(data) })
        })
    },
    serviceUsage() {
        return new Promise(resolve => {
            ApiService.get("statistiques/service-usage").then(data => { resolve(data) })
        })
    },

    lastUsers() {
        return new Promise(resolve => {
            ApiService.get("statistiques/last-users").then(data => { resolve(data) })
        })
    },

    orderEvolution() {
        return new Promise(resolve => {
            ApiService.get("statistiques/order-evolution").then(data => { resolve(data) })
        })
    },

}